<template>
    <div>
        <div class="form-section-heading">
            {{ trans('users.headline.client') }}
        </div>
        <section class="section">
            <div class="section-row">
                <div class="section-row__col section-row__col--one-half">
                    <div class="user-summary-client">
                        <div class="user-summary-client__icon">
                            <colored-letter-square slot="role"
                                :name="client.name || ''"
                                :length="2"
                                :color="'#9acd7d'"
                            >
                            </colored-letter-square>
                        </div>
                        <div class="user-summary-client-info">
                            <div class="user-summary-client-info__primary">
                                {{ client.name }}
                            </div>
                            <div class="user-summary-client-info__secondary">
                                {{ client.city }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <div class="form-section-heading">
            {{ trans('users.headline.user_information') }}
        </div>
        <section class="section">
            <div class="section-row">
                <div class="section-row__col section-row__col--one-half">
                    <div class="label">
                        {{ trans('users.label.full_name') }}
                    </div>

                    <div class="value">
                        {{ trans('users.label.' + userFormFields.gender ) }} {{ userFormFields.title }} {{ userFormFields.firstname }} {{ userFormFields.lastname }}
                    </div>
                </div>

                <div class="section-row__col section-row__col--one-half"
                    v-if="userFormFields.street || userFormFields.zip || userFormFields.city">
                    <div class="label">
                        {{ trans('users.label.address') }}
                    </div>

                    <div class="value">
                        {{ userFormFields.street }}, {{ userFormFields.zip }} {{ userFormFields.city }}
                    </div>
                </div>
            </div>

            <div class="section-row">
                <div class="section-row__col section-row__col--one-half">
                    <div class="label">
                        {{ trans('users.label.email') }}
                    </div>

                    <div class="value">
                        {{ userFormFields.email }}
                    </div>
                </div>

                <div class="section-row__col section-row__col--one-half" v-if="userFormFields.internal_id">
                    <div class="label">
                        {{ trans('users.label.internal_id') }}
                    </div>

                    <div class="value">
                        {{ userFormFields.internal_id }}
                    </div>
                </div>
            </div>

            <div class="section-row section-row--wrap">
                <div class="section-row__col section-row__col--one-half" v-for="(field, index) in userFormFields.specificUserFields" :key="index">
                    <label :class="['label',  {'label--required': field.required}]">
                        {{ field.label }}
                    </label>

                    <div class="value">
                        {{ field.value || '-' }}
                    </div>
                </div>
            </div>

            <div class="section-row">
                <div class="section-row__col section-row__col--one-half">
                    <div class="label">
                        {{ trans('users.label.role') }}
                    </div>

                    <div class="value">
                        <span v-for="(role, index) in userFormFields.roles" :key="index">{{ roleName(role, index) }}</span>
                    </div>
                </div>

                <div class="section-row__col section-row__col--one-half" v-if="userCourseAssignmentFormFields.userGroups && userCourseAssignmentFormFields.userGroups.length != 0">
                    <div class="label">
                        {{ trans('users.headline.user_group_assignment') }}
                    </div>

                    <div class="value" v-for="(selectedUserGroup, index) in userCourseAssignmentFormFields.userGroups" :key="index">
                        {{ getUserGroupName(selectedUserGroup) }}
                    </div>
                </div>
            </div>
        </section>

        <course-info-table
            :userCourseAssignmentFormFields="userCourseAssignmentFormFields"
        ></course-info-table>
    </div>
</template>

<script>

export default {
    props: {
        'client': {
            type: Object,
            default: () => { return {}; },
        },
        'userFormFields': {
            type: Object,
            default: () => { return {}; },
        },
        'userCourseAssignmentFormFields' : {
            type: Object,
            default: () => { return {}; },
        },
    },

    methods: {
        getUserGroupName(selectedUserGroup) {
            var groupName = selectedUserGroup.userGroup ? selectedUserGroup.userGroup.label : "";

            return groupName;
        },

        roleName(id, index) {
            var names = [];
            var length = this.userFormFields.roles.length;
            names[5] = this.trans('users.role.client_admin');
            names[6] = this.trans('users.role.controller');
            names[7] = this.trans('users.role.end_user');
            names[8] = this.trans('users.role.supervisor');

            if ( length > 1 && index < length - 1) {
                return (names[id] + ', ')
            }
            return (names[id]);
        },
    },
}
</script>
